import React from "react";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import styles from "./PeakOurFridge.module.scss";
import { useHistory } from "react-router";
import { ROUTE_OUR_KITCHEN, REACT_APP_CLOUD_FRONT } from "../../../constants";
const PeakOurFridge = () => {
  const isItMobile = useCheckMobileScreen();
  const history = useHistory();
  return (
    <>
      <div className={`${styles.PeakFridgeWrapper}`}>
        <div className={styles.backgroundImage}>
          <div className={` ${styles.imageWrapper} `}>
            {isItMobile ? (
              <img src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/bannerMobile.png`} alt="Mobile Banner" />
            ) : (
              <img src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/banerDesktop.png`} alt="Desktop Banner" />
            )}
          </div>
          <div>
            <button
              className={`btn btn-large ${styles.order_btn}`}
              onClick={() => {
                history.push(ROUTE_OUR_KITCHEN);
              }}
            >
              PEEK OUR FRIDGE
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PeakOurFridge;
